import { useNavigate } from "react-router"

export const PresentationComp = ()=>{

  const navigate = useNavigate();

    return(
        <div className="flex lg:flex-row flex-col bg-base-300 rounded-box justify-between items-center p-4 m-4">
            
        <div className="flex lg:flex-row flex-col">
          <img
            alt="robot"
            src="/image/robot_succeed.png"
            className="w-[72px] h-[72px] object-cover"
          />
          <div className="w-fit text-sm lg:text-md">
            <p className="">
              Tout d'abord on tient à te féliciter car on sait le pas énorme
              que cela demande à vouloir lancer son projet!
            </p>
            <p>Voici ton rapport détaillé après.</p>
            <p>
              {" "}
              Après analyse, nous avons pu constater qu'il y'a quelque point
              sur lesquelles tu aurais des faiblesse qui pourrait te faire
              trop payer ou payer un projet qui ne te portera pas ce que tu
              espères.
            </p>
            <p> Pour cela nous souhaiterions prendre rendez vous </p>
            <p>
              En attendant nous te fournissons ce rapport pour que tu
              puisses analysé l'état de ta démarche entrepreunarial
            </p>
          </div>
        </div>
        <button
          onClick={()=>{navigate("/subscription")}}
          className="btn btn-neutral"
        >
          Prendre un rendez vous
        </button>
      </div>
    )
}